import React, { Component } from "react";
import { applyDataTable, destroyDataTable } from "../../custom/dataTable";
import Edit from "../../../Assets/img/svg/edit.svg";
import Delete from "../../../Assets/img/svg/delete.svg";
import FilterIcon from "../../../Assets/img/svg/FilterIcon.svg";
import del from "../../../Assets/img/svg/Del.svg";
import Autocomplete from "react-autocomplete";
import $ from "jquery";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../Assets/jss/customStyle";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import moment from "moment";
import axios from "axios";
import API from "../../../helpers/endpointService";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Active from "../../../Assets/img/svg/active.svg";
import Deactive from "../../../Assets/img/svg/deactive.svg";
import { isUserRole } from "../../Constants.js";

const mmpluser = "mmpladmin@marinemechanics.biz";
const mmpluserprod = "inspections@marinemechanics.biz";
const currentUser = JSON.parse(localStorage.getItem("currentUser"))?.email;

class LViewExternalClientShips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      ShipList: [],
    };
  }

  componentDidMount() {
    console.log(JSON.parse(localStorage.getItem("currentUser")));
    const { dispatch } = this.props;
    this.getShipInfoList();
    localStorage.removeItem("EditUser");
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
  }

  getShipInfoList = () => {
    let apiUrl = API.GET_EXTERNAL_CLIENT;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.ShipList = response.data;
          this.setState({});
        } else {
        }
      })
      .catch((error) => {
        // this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    $("#ESHIP1 .MuiListItemText-primary").addClass("spanTopBar")
    $("#ExterMngt1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#ExterMngt11").addClass("d-none");
    $("#ExterMngt11").removeClass("d-block");
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  resize1 = () => {
    $("#ESHIP1 .MuiListItemText-primary").addClass("spanTopBar")
    $("#ExterMngt1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#ExterMngt11").removeClass("d-none");
    $("#ExterMngt11").addClass("d-block");
    $("#ECPAT .MuiListItemText-primary").addClass("fw-bolder")
    $("#ECPA").addClass("active-color")
  };

  AddNew = () => {
    this.props.navigate("/activesampleships/add");
  };
  EditExteralClient = (email) => {
    this.props.navigate(`/activesampleships/edit`);
  };
  BackPage = () => {
    this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
    this.setState({});
    this.dataTable(this.state.searchData);
  };

  NextPage = () => {
    this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
    this.setState({});
    this.dataTable(this.state.searchData);
  };

  Navigation = (Id) => {
    localStorage.setItem("DashId", Id);
  };
  render() {
    let { classes, menuToggle } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4 mob-topfixed  ">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem>
                    <ListItemText
                      id={"ESHIP" + 1}
                      className="textNaviIcon"
                      primary="Sample Ships"
                    />
                    <NavigateNextIcon
                      id="ESHIP"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Active Sample Ships</h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        <div
          className="ml-auto mt-138"
          style={{
            overflowX: "hidden",
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <button className={classes.button} onClick={this.AddNew} disabled={this.state.ShipList.length > 0 ? true : false}>
                      <i
                        className="fa fa-plus pr-2"
                        style={{ color: "#499AC8" }}
                      ></i>
                      Add Ships
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <>
              <div className="row  border-bottom">
                <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                  <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2">
                    <button
                     disabled={this.state.ShipList.length > 0 ? true : false}
                      className={classes.button}
                      onClick={this.AddNew}
                      style={{ minWidth: "70px" }}
                    >
                      <i
                        className="fa fa-plus pr-2"
                        style={{ color: "#499AC8" }}
                      ></i>
                      Add Ships
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
          <div
            className="row pb-4"
            style={{ margin: this.state.isMobile ? "auto" : "5px" }}
          >
            <div className="row px-3">
              <div className="col-10 p-2">
                {this.state.isMobile ? <></> : <h6>Active Sample Ships</h6>}
              </div>
              <div className="col-2 p-2"></div>
            </div>
            <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
              <div className="table-responsive mb-4" style={{ width: "100%" }}>
                <table id="staffTable" className="table table-borderless">
                  <thead>
                    <tr className="table-active border-bottom">
                      <th
                        className="border-top border-right border-left"
                        width="85%"
                        colSpan={2}
                        onClick={() => this.handleSort("ships", 4)}
                      >
                        <span className="fw-bold" style={{ color: "#000000" }}>
                          Ships
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-bottom">
                      {this.state.ShipList.length != 0 ? (
                        <>
                        
                          <td className="align-middle border-right border-left" width="85%">
                            <>
                              {" "}
                              {this.state.ShipList.length === 0
                                ? " "
                                : this.state.ShipList.length > 1
                                ? this.state.ShipList.map((item) => {
                                    return item.ShipName;
                                  }).join("," + " ")
                                : this.state.ShipList.map((i) =>
                                    i.ShipName.toString()
                                  )}
                            </>
                          </td>
                          <td className="border-right align-items-center">
                            <button
                              type="button"
                              class={
                                this.state.isMobile
                                  ? "btn btn-secondary"
                                  : " btn btn-secondary py-2 px-4"
                              }
                              data-dismiss="modal"
                              style={{
                                backgroundColor: "#499AC8",
                                border: "none",
                              }}
                              onClick={() => {
                                this.EditExteralClient();
                              }}
                            >
                              <span className="">Edit Ships</span>
                            </button>
                          </td>
                        </>
                      ) : (
                        <td className="align-middle border-right border-left text-center">
                          No ships to assign the external client
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            class="modal fade p-5 mt-5"
            id="deletepopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div class="modal-dialog" role="document">
              <div
                class={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div class="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 class="fw-bold">Are you sure you want to delete?</h5>
                  </div>
                </div>
                <div class="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={() => this.DeleteItem()}
                  >
                    <span className="">Delete</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal1"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    onClick={() => {
                      window.$("#deletepopup").modal("hide");
                    }}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*   <div className={`${classes.pagination}`}>
          <div className={`${classes.paginationItem}`}>
            {this.state.searchData.PageNumber == 1 ? (
              <></>
            ) : (
              <ArrowBackIcon
                className={classes.arrow}
                onClick={() => this.BackPage()}
              />
            )}
            <span className="pl-2 pr-2">
              Page {this.state.searchData.PageNumber}
            </span>
            {this.state.searchData.PageNumber ==
              this.props.User_Table?.pagination?.PageCount ||
            this.props.User_Table?.pagination?.PageCount == 0 ? (
              <></>
            ) : (
              <ArrowForwardIcon
                className={classes.arrow}
                onClick={() => this.NextPage()}
              />
            )}
          </div>
        </div> */}
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    User_Table: state.UserReducer.User_Table,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(LViewExternalClientShips))
);
